export enum CompletionType {
    NONE = 0,
    ENDAFTER = 1,
    ENDBY = 2
}